import React, { PureComponent, ReactNode } from 'react';

import DocumentIcon from '@atlaskit/icon/glyph/document';
import File, { FileProps, FileStatelessProps } from '@atlassian/bitkit-file';

import * as styles from './file-wrapper.style';

// Fancy way of taking the same `renderFilePath` type that's optional
// but making it required here. Other "simpler" methods of setting this up
// weren't enough for the TS compiler
type FileWrapperProps = Omit<FileProps, 'renderFilePath'> & {
  renderFilePath: Required<
    Pick<FileStatelessProps, 'renderFilePath'>
  >['renderFilePath'];
};

class FileWrapper extends PureComponent<FileWrapperProps> {
  renderFilePath = (path: string, copyButton: ReactNode) => (
    <styles.PathWrapper>
      {this.props.renderFilePath(path, copyButton)}
    </styles.PathWrapper>
  );

  render() {
    return (
      <File
        icon={<DocumentIcon label="" />}
        isExpanded
        isCollapsible={false}
        {...this.props}
        renderFilePath={this.renderFilePath}
      />
    );
  }
}

export default FileWrapper;
